module.exports = __webpack_public_path__ + "assets/img/carrot-idle.a81faae3.png";